(function () {
  if (window.__klPdp) return;
  window.__klPdp = true;
  var d = document, root = d.documentElement;
  var reduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || root.classList.contains('kla-still');
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;

  /* ---------- Sticky buy bar ---------- */
  function bar() {
    var bar = d.querySelector('[data-kl-bar]');
    var main = d.querySelector('product-info');
    if (!bar || !main) return;
    var submit = main.querySelector('.product-form__submit');
    var btn = bar.querySelector('[data-kl-bar-btn]');
    var priceEl = bar.querySelector('[data-kl-bar-price]');
    var labelEl = btn && btn.querySelector('span');
    if (!submit || !btn) return;
    var target = submit.closest('.product-form') || submit;

    function sync() {
      var p = main.querySelector('.price .price-item--last');
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
      var cur = main.querySelector('.product-form__submit');
      if (!cur) return;
      var off = cur.disabled || cur.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      var l = cur.querySelector('span');
      if (labelEl && l && l.textContent.trim()) labelEl.textContent = l.textContent.trim();
    }
    function setOn(on) {
      bar.classList.toggle('is-on', on);
      d.body.classList.toggle('kl-bar-on', on);
      if (on) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setOn(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    }
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    btn.addEventListener('click', function () {
      var cur = main.querySelector('.product-form__submit');
      if (cur && !cur.disabled) cur.click();
    });
    sync();
  }

  /* ---------- Film ---------- */
  function film(G, ST) {
    var filmEl = d.querySelector('.kl-film');
    if (!filmEl) return;
    var rows = [].slice.call(filmEl.querySelectorAll('.kl-row'));
    var head = filmEl.querySelector('.kl-film__head');
    var lead = filmEl.querySelector('.kl-film__lead');
    root.classList.add('kl-pdp-js');

    if (lead && !lead.children.length) {
      lead.innerHTML = lead.textContent.trim().split(/\s+/).map(function (w) { return '<span class="kl-w"><span>' + w.replace(/</g, '&lt;') + '</span></span>'; }).join(' ');
      G.from(lead.querySelectorAll('.kl-w > span'), { yPercent: 118, duration: 1.2, stagger: 0.09, ease: 'expo.out', scrollTrigger: { trigger: lead, start: 'top 85%', once: true } });
    }

    /* 3D product deck */
    var deck = filmEl.querySelector('.kl-deck__stack');
    if (deck) {
      G.set(deck, { transformPerspective: 1200, rotationX: 8, rotationY: -14 });
      G.from(filmEl.querySelector('.kl-deck'), { opacity: 0, y: 90, scale: 0.86, duration: 1.5, ease: 'expo.out', scrollTrigger: { trigger: head, start: 'top 80%', once: true } });
      var layers = deck.querySelectorAll('.kl-deck__c');
      if (head) G.to(deck, { rotationY: 6, ease: 'none', scrollTrigger: { trigger: head, start: 'top 90%', end: 'bottom 10%', scrub: 0.8 } });
      if (fine && head) {
        var rxq = G.quickTo(deck, 'rotationX', { duration: 0.9, ease: 'power3' });
        var ryq = G.quickTo(deck, 'rotationY', { duration: 0.9, ease: 'power3' });
        head.addEventListener('pointermove', function (e) {
          var r = head.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
          ryq(-8 + px * 30); rxq(6 - py * 20);
        });
        head.addEventListener('pointerleave', function () { ryq(-14); rxq(8); });
      }
    }

    /* light that follows the cursor */
    if (fine) {
      var raf = 0;
      filmEl.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = filmEl.getBoundingClientRect();
          filmEl.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          filmEl.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      });
    }

    rows.forEach(function (r) {
      var t = r.querySelector('.kl-row__t');
      var b = r.querySelector('.kl-row__b');
      if (t && !t.querySelector('.kl-fw')) {
        var txt = t.textContent.trim();
        t.setAttribute('aria-label', txt);
        t.innerHTML = txt.split(/\s+/).map(function (w) { return '<span class="kl-fw" aria-hidden="true">' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>'; }).join(' ');
        G.to(t.querySelectorAll('.kl-fw'), { color: '#ffffff', webkitTextStrokeColor: '#ffffff', ease: 'none', stagger: 0.6, scrollTrigger: { trigger: r, start: 'top 82%', end: 'top 30%', scrub: 0.4 } });
      }
      if (b) G.fromTo(b, { y: 70, opacity: 0 }, { y: -8, opacity: 1, ease: 'none', scrollTrigger: { trigger: r, start: 'top 92%', end: 'top 42%', scrub: 0.6 } });
    });

    var rowsSpec = d.querySelectorAll('.kl-spec dl > div');
    if (rowsSpec.length) G.from(rowsSpec, { opacity: 0, y: 24, duration: 0.8, stagger: 0.06, ease: 'power3.out', scrollTrigger: { trigger: '.kl-spec', start: 'top 82%', once: true } });

    var cards = d.querySelectorAll('.kl-promise__g > div');
    if (cards.length) G.from(cards, { y: 80, opacity: 0, duration: 1.1, stagger: 0.1, ease: 'expo.out', clearProps: 'opacity,transform', scrollTrigger: { trigger: '.kl-promise', start: 'top 82%', once: true } });

    var qs = d.querySelectorAll('.kl-q');
    if (qs.length) G.from(qs, { y: 44, opacity: 0, duration: 1, stagger: 0.09, ease: 'expo.out', clearProps: 'opacity,transform', scrollTrigger: { trigger: '.kl-faq', start: 'top 72%', once: true } });
    var fh = d.querySelector('.kl-faq__h');
    if (fh && !fh.children.length) {
      fh.innerHTML = fh.textContent.trim().split(/\s+/).map(function (w) { return '<span class="kl-w"><span>' + w.replace(/</g, '&lt;') + '</span></span>'; }).join(' ');
      G.from(fh.querySelectorAll('.kl-w > span'), { yPercent: 118, duration: 1.2, stagger: 0.09, ease: 'expo.out', scrollTrigger: { trigger: fh, start: 'top 85%', once: true } });
    }

    /* the gold strip speeds up with your scroll */
    var mrow = d.querySelector('.kl-pdpm__row');
    if (mrow && mrow.getAnimations) {
      var target = 1, rate = 1;
      ST.create({ onUpdate: function (self) { target = 1 + Math.min(Math.abs(self.getVelocity()) / 260, 6); } });
      G.ticker.add(function () {
        target += (1 - target) * 0.07;
        rate += (target - rate) * 0.15;
        var a = mrow.getAnimations()[0];
        if (a) a.playbackRate = rate;
      });
    }
  }

  /* ---------- Show effects (GSAP) ---------- */
  function show() {
    var G = window.gsap, ST = window.ScrollTrigger;
    var main = d.querySelector('product-info');
    if (!G || !ST || !main) return;
    G.registerPlugin(ST);
    var sec = main.closest('.shopify-section') || main.closest('section') || main.parentNode;
    var gal = main.querySelector('.product__media-wrapper');
    var info = main.querySelector('.product__info-container');
    var h1 = main.querySelector('.product__title h1');
    var ghost, o1, o2;

    /* ghost word + orbs behind the buy box, with mouse depth */
    try {
      sec.classList.add('kl-pdp-sec');
      var words = ((h1 && h1.textContent) || d.title).trim().split(/\s+/).slice(0, 2).join(' ');
      ghost = d.createElement('div');
      ghost.className = 'kl-ghost'; ghost.setAttribute('aria-hidden', 'true');
      var gs = d.createElement('span'); gs.textContent = words + ' ' + words;
      ghost.appendChild(gs);
      o1 = d.createElement('i'); o1.className = 'kl-orb kl-orb--a';
      o2 = d.createElement('i'); o2.className = 'kl-orb kl-orb--b';
      sec.insertBefore(o2, sec.firstChild); sec.insertBefore(o1, sec.firstChild); sec.insertBefore(ghost, sec.firstChild);
      G.to(gs, { xPercent: -30, ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (fine) {
        var gx = G.quickTo(ghost, 'x', { duration: 1.2, ease: 'power3' });
        var gy = G.quickTo(ghost, 'y', { duration: 1.2, ease: 'power3' });
        var ax = G.quickTo(o1, 'x', { duration: 1.6, ease: 'power3' }), ay = G.quickTo(o1, 'y', { duration: 1.6, ease: 'power3' });
        var bx = G.quickTo(o2, 'x', { duration: 1.6, ease: 'power3' }), by = G.quickTo(o2, 'y', { duration: 1.6, ease: 'power3' });
        sec.addEventListener('pointermove', function (e) {
          var r = sec.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
          gx(px * -50); gy(py * -30);
          ax(px * 120); ay(py * 80);
          bx(px * -90); by(py * -60);
        });
      }
    } catch (e) {}

    /* intro */
    var ready = false;
    try {
      if (h1 && !h1.children.length) {
        var parts = h1.textContent.trim().split(/\s+/);
        h1.setAttribute('aria-label', h1.textContent.trim());
        h1.innerHTML = parts.map(function (w) { return '<span class="kl-w" aria-hidden="true"><span>' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span></span>'; }).join(' ');
        G.from(h1.querySelectorAll('.kl-w > span'), { yPercent: 115, duration: 1.1, stagger: 0.07, ease: 'expo.out', delay: 0.25 });
      }
      if (gal) G.from(gal, { opacity: 0, y: 70, scale: 0.95, duration: 1.2, ease: 'expo.out', clearProps: 'opacity,transform', onComplete: function () { ready = true; } });
      var kids = info ? [].slice.call(info.children).filter(function (k) { return !k.classList.contains('product__title'); }) : [];
      if (kids.length) G.from(kids, { opacity: 0, y: 38, duration: 0.9, stagger: 0.08, ease: 'power3.out', delay: 0.3, clearProps: 'opacity,transform' });
    } catch (e) {}

    /* 3D tilt on the gallery */
    /* tilt only the photo list, never the wrapper: a transformed wrapper would trap the fullscreen viewer */
    var tiltEl = gal && gal.querySelector('.product__media-list');
    if (fine && tiltEl) {
      G.set(tiltEl, { transformPerspective: 1100 });
      var rx = G.quickTo(tiltEl, 'rotationX', { duration: 0.7, ease: 'power3' });
      var ry = G.quickTo(tiltEl, 'rotationY', { duration: 0.7, ease: 'power3' });
      gal.addEventListener('pointermove', function (e) {
        if (!ready) return;
        var r = gal.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        ry(px * 6); rx(-py * 6);
      });
      gal.addEventListener('pointerleave', function () { rx(0); ry(0); });
    }

    /* the buy button leans toward the cursor */
    if (fine) {
      main.addEventListener('pointermove', function (e) {
        var b = e.target.closest && e.target.closest('.product-form__submit');
        if (!b || b.disabled) return;
        var r = b.getBoundingClientRect();
        G.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.1, y: (e.clientY - r.top - r.height / 2) * 0.22, duration: 0.45, ease: 'power3.out', overwrite: 'auto' });
      });
      main.addEventListener('pointerout', function (e) {
        var b = e.target.closest && e.target.closest('.product-form__submit');
        if (!b || (e.relatedTarget && b.contains(e.relatedTarget))) return;
        G.to(b, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1,.5)', overwrite: 'auto', onComplete: function () { G.set(b, { clearProps: 'transform' }); } });
      });
    }

    try { film(G, ST); } catch (e) {}

    /* add to cart: the product flies into the cart */
    main.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-form__submit');
      if (!b || b.disabled) return;
      var src = main.querySelector('.product__media-wrapper img');
      var cart = d.querySelector('#cart-icon-bubble');
      if (!src || !cart) return;
      var a = src.getBoundingClientRect(), c = cart.getBoundingClientRect();
      if (!a.width || !c.width) return;
      var size = 110;
      var cy = Math.max(0, Math.min(a.top + a.height / 2, window.innerHeight));
      var fl = d.createElement('img');
      fl.src = src.currentSrc || src.src; fl.alt = ''; fl.className = 'kl-fly';
      fl.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (cy - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
      d.body.appendChild(fl);
      var tx = c.left + c.width / 2 - (a.left + a.width / 2);
      var ty = c.top + c.height / 2 - cy;
      G.to(fl, { x: tx, duration: 1, ease: 'power1.inOut' });
      G.to(fl, { keyframes: [{ y: -90, duration: 0.35, ease: 'power2.out' }, { y: ty, duration: 0.65, ease: 'power2.in' }] });
      G.to(fl, { scale: 0.18, rotation: 300, opacity: 0.9, duration: 1, ease: 'power2.in', onComplete: function () {
        fl.remove();
        G.fromTo(cart, { scale: 1.45 }, { scale: 1, duration: 0.8, ease: 'elastic.out(1,.4)' });
      } });
    }, true);

    window.addEventListener('load', function () { ST.refresh(); });
  }

  function init() {
    bar();
    if (reduce) return;
    if (window.gsap && window.ScrollTrigger) show();
    else window.addEventListener('load', show);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
